export const Text = ({
  style,
  title,
  panel,
  bold,
  italic,
  size,
  color,
  center,
  upCase,
  value,
  className
}) => (
  <div
    className={(className || '') + ' textContainer'}
    style={{
      fontWeight: bold ? 'bold' : 'normal',
      fontStyle: italic ? 'italic' : 'normal',
      fontSize: size || 'var(--font-size-md)',
      fontFamily: 'var(--font-family)',
      ...(color && { color }),
      textAlign: center ? 'center' : 'start',
      ...style
    }}
  >
    {upCase ? value.toUpperCase() : value}
  </div>
)
